import { Ring } from '@blocks/Loading'
import useLoading from '@hooks/useLoading'
import { ReactComponent as UploadIcon } from '@icons/upload.svg'
import { colors } from '@styles/vars'
import React, { forwardRef } from 'react'
import styled from 'styled-components'

function File({ label, ...attributes }: Props, ref: React.Ref<HTMLInputElement>) {
    const loading = useLoading()

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        e.persist()

        loading.until(async () => await attributes.onChange?.(e))
    }

    return (
        <FileStyles>
            <input onChange={handleChange} {...attributes} type="file" ref={ref} />
            <label htmlFor={attributes.id}>
                {loading.state ? <Ring /> : <UploadIcon />}
                <span>{label || "Choose..."}</span>
            </label>
        </FileStyles>
    )
}

export default forwardRef(File)

const FileStyles = styled.div`
    input {
        position: absolute;
        z-index: -1;
        width: 0;
        height: 0;
        opacity: 0;
    }

    label {
        display: flex;
        align-items: center;

        & > span {
            display: block;
        }

        svg {
            fill: ${colors.black};
            margin-right: 10px;
        }

        border: 1px solid ${colors.border};
        color: ${colors.black};
        border-radius: 4px;
        cursor: pointer;
        background: ${colors.white};
        font-weight: 700;
        padding: 7px 12px;
        
        &:hover {
            background: ${colors.greyBackground};
        }
    }
`

interface Props extends React.InputHTMLAttributes<HTMLInputElement> { 
    label?: React.ReactNode
    onChange?(e: React.ChangeEvent<HTMLInputElement>): Promise<void> | void
}